import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "../../dashboard/claimLitigation/litigation.scss";
import { updateFlag, fetchFlagDetails } from "./litigationApi";
import AsteriskSymbol from "../../reusableComponents/AsteriskSymbol";
import { flagClaimsMaxLength, Litigationvalidtypes, REGEX, SUSPICIOUS } from "../../consts";
import { Button, Modal, ModalBody, ModalFooter } from "react-bootstrap";
import LoadingPage from "../../reusableComponents/loader/loadingPage";
import FileUpload from "../../utilsComponent/fileUpload";
import { formatDocumentDetails } from "./helper";
import FlagClaimsAccordion from "../../utilsComponent/FlagClaimsAccordion";

const Suspicious = (props) => {
  const { claimDetailCookie, roleDataCookie, getClaimDetails } = props;
  const [loading, setLoading] = useState(false);
  const [flagSuspicious, setFlagSuspicious] = useState(false);
  const [remarksInModal, setRemarksInModal] = useState("");
  const [suspiciousModal, setSuspiciousModal] = useState(false);
  const [previousFlagSuspicious, setPreviousFlagSuspicious] = useState(false);
  const [addedFiles, setAddedFiles] = useState([]);
  const [rows, setRows] = useState([]);


  useEffect(() => {
    if (claimDetailCookie?.claimNo) {
      getSuspiciousDetails();
    }
  }, [claimDetailCookie?.claimNo]);

  const getSuspiciousDetails = () => {
    setLoading(true);
    fetchFlagDetails(claimDetailCookie?.claimNo, SUSPICIOUS, setLoading)
      .then((data) => {
      setRows(data?.records)
      if (!data?.records?.length) {
        setFlagSuspicious(false);
        setPreviousFlagSuspicious(false);
      } else {
        const latestActivity = data?.records[0]?.activityName || "";
        if (latestActivity === "Suspicious Unflagged") {
          setFlagSuspicious(false);
          setPreviousFlagSuspicious(true);
        } else if (latestActivity === "Suspicious Flagged" || latestActivity === "Suspicious Re-flagged") {
          setFlagSuspicious(true);
          setPreviousFlagSuspicious(true);
        }
      }
      })
      .catch((error) => {
        console.error("Error fetching Suspicious details:", error);
        setFlagSuspicious(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleFlagSuspicious = () => {
    const isSuspiciousChecked = !flagSuspicious;
    setPreviousFlagSuspicious(flagSuspicious);
    setFlagSuspicious(isSuspiciousChecked);
    setSuspiciousModal(true);
  };
  const submitSuspicious = async () => {
    if (
      claimDetailCookie.assignedTo === "Unassigned" ||
      !claimDetailCookie.assignedTo
    ) {
      toast.error("Please Assign Claims Handler.");
      return;
    }
    if (!remarksInModal) {
      toast.error("Please enter remarks");
      return;
    }
    setLoading(true);
    const response = await updateFlag({
      claimId: claimDetailCookie.claimNo,
      flagId: SUSPICIOUS,
      userId: roleDataCookie?.userID,
      remarks: remarksInModal,
      documentId: addedFiles.map((list) => list.id)
    },setLoading);
    setLoading(false);
    toast.success(response);
    getClaimDetails(claimDetailCookie?.claimNo);
    getSuspiciousDetails();
    setRemarksInModal("");
    setSuspiciousModal(false);
    setAddedFiles([]);
  };
  const handleModalClose = () => {
    setFlagSuspicious(previousFlagSuspicious);
    setSuspiciousModal(false);
    setRemarksInModal("");
    setAddedFiles([]);
  };
  return loading ? (
    <LoadingPage />
  ) : (
    <div>
      <div>
        <div className="potential">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="flagSuspicious"
              checked={flagSuspicious}
              onClick={handleFlagSuspicious}
              readOnly
            />
            <label className="form-check-label mb-3" htmlFor="flagSuspicious">
              Flag Suspicious
            </label>
          </div>
          {suspiciousModal && (
            <Modal
              show={suspiciousModal}
              isOpen={suspiciousModal}
              centered={true}
              backdrop={"static"}
              className="fraud-modal-width"
            >
              <ModalBody>
                <div>
                  <label>
                    <h6>
                      Remarks <AsteriskSymbol />
                    </h6>
                  </label>
                </div>
                <div>
                  <textarea
                    className="remarksPotential"
                    placeholder="Please enter remarks"
                    value={remarksInModal}
                    onChange={(e) => {
                      const suspiciousRemarks = e.target.value
                        .replace(REGEX.ALPHANUM_SPACE, "")
                        .slice(0, flagClaimsMaxLength);
                      setRemarksInModal(suspiciousRemarks);
                    }}
                  ></textarea>
                  <div className="remarks-text-info right">
                    <p>
                      {remarksInModal.length}/{flagClaimsMaxLength}
                    </p>
                  </div>
                  <FileUpload
                    validtype={Litigationvalidtypes}
                    addedFiles={addedFiles}
                    setAddedFiles={setAddedFiles}
                    text={"Upload File"}
                    module="litigation"
                    roleDataCookie={roleDataCookie}
                    doctypeName="litigation"
                    tran_id={claimDetailCookie?.claimNo}
                />
                </div>
              </ModalBody>
              <ModalFooter className="justify-content-center">
                <Button
                  variant="outline-danger"
                  onClick={handleModalClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="outline-success"
                  onClick={() => submitSuspicious()}
                >
                  Submit
                </Button>
              </ModalFooter>
            </Modal>
          )}
          <FlagClaimsAccordion
            rows={rows}
            formatDocumentDetails={formatDocumentDetails}
          />
        </div>
      </div>
    </div>
  );
};

export default Suspicious;
